import React from 'react'
import { Button, Form, FormFeedback, FormGroup, Input, Label, Modal, ModalBody, ModalHeader } from 'reactstrap'
import { useFormik } from 'formik';
import * as Yup from "yup";
import "flatpickr/dist/themes/material_blue.css";
import FlatPickr from "react-flatpickr";
import { useDispatch } from 'react-redux';
import { createGatePassApproval } from 'store/actions';
import moment from 'moment';

const CreateGatePassReq = ({ isShowModal, setIsShowModal }) => {
    const dispatch = useDispatch();

    const validation = useFormik({
        // enableReinitialize : use this flag when initial values needs to be changed
        enableReinitialize: true,

        initialValues: {
            reason: "",
            requested_checkout: "",
            requested_checkin: ""
        },
        validationSchema: Yup.object({
            reason: Yup.string().required("Please Enter Checkout reason"),
            requested_checkout: Yup.string().required("Please Select Checkout Date And Time"),
            requested_checkin: Yup.string().required("Please Select CheckIn Date And Time")


        }),
        onSubmit: values => {
            console.log(values)
            dispatch(createGatePassApproval(values));
            setIsShowModal(false)
            validation.resetForm()
        },
    })


    return (
        <Modal isOpen={isShowModal} toggle={() => setIsShowModal(false)}>
            <ModalHeader tag={"h4"} toggle={() => setIsShowModal(false)}>
                Create Gate Pass Approval
            </ModalHeader>

            <ModalBody>
                <Form
                    onSubmit={e => {
                        e.preventDefault()
                        validation.handleSubmit()
                    }}>
                    <FormGroup>
                        <Label>Checkout Reason</Label>
                        <Input
                            name='reason'
                            id='reason'
                            type='textarea'
                            placeholder='Enter Reason'
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            // disabled={isEdit}
                            value={validation.values.reason || ""}
                            invalid={
                                validation.touched.reason && validation.errors.reason
                                    ? true
                                    : false
                            } />


                        {validation.touched.reason && validation.errors.reason ? (
                            <FormFeedback type="invalid">
                                {validation.errors.reason}
                            </FormFeedback>
                        ) : null}

                    </FormGroup>


                    <FormGroup>
                        <Label for='requested_checkout'>Select Checkout Date And Time</Label>
                        <FlatPickr
                            className="form-control"
                            name="requested_checkout"
                            placeholder="Select Checkout Date And Time"
                            options={{
                                enableTime: true, // ✅ enable time picker
                                dateFormat: "d/m/Y H:i", // ✅ format for date and time
                                time_24hr: true, // optional: 24-hour time format
                            }}
                            value={
                                validation.values.requested_checkout
                                    ? moment(validation.values.requested_checkout).format("DD/MM/YYYY HH:mm")
                                    : null
                            }
                            // disabled={isEdit}
                            onBlur={validation.handleBlur}
                            invalid={
                                validation.touched.requested_checkout && validation.errors.requested_checkout
                                    ? true
                                    : false
                            }
                            onChange={(selectedDates) => {
                                console.log("Selected Date:", selectedDates[0]);
                                validation.setFieldValue(
                                    "requested_checkout",
                                    moment(selectedDates[0]).format("YYYY-MM-DD HH:mm:ss")
                                );
                            }}
                        />
                        {validation.errors.requested_checkout ? (
                            <p className="text-danger" style={{ fontSize: "10px" }}>
                                {validation.errors.requested_checkout}
                            </p>
                        ) : null}
                    </FormGroup>



                    <FormGroup>
                        <Label for='requested_checkin'>Select Checkin Date And Time</Label>
                        <FlatPickr
                            className="form-control"
                            name="requested_checkin"
                            placeholder="Select Checkin Date And Time"
                            options={{
                                enableTime: true, // ✅ enable time picker
                                dateFormat: "d/m/Y H:i", // ✅ format for date and time
                                time_24hr: true, // optional: 24-hour time format
                            }}
                            value={
                                validation.values.requested_checkin
                                    ? moment(validation.values.requested_checkin).format("DD/MM/YYYY HH:mm")
                                    : null
                            }
                            // disabled={isEdit}
                            onBlur={validation.handleBlur}
                            invalid={
                                validation.touched.requested_checkin && validation.errors.requested_checkin
                                    ? true
                                    : false
                            }
                            onChange={(selectedDates) => {
                                console.log("Selected Date:", selectedDates[0]);
                                validation.setFieldValue(
                                    "requested_checkin",
                                    moment(selectedDates[0]).format("YYYY-MM-DD HH:mm:ss")
                                );
                            }}
                        />
                        {validation.errors.requested_checkin ? (
                            <p className="text-danger" style={{ fontSize: "10px" }}>
                                {validation.errors.requested_checkin}
                            </p>
                        ) : null}
                    </FormGroup>


                    <FormGroup>
                        <Button type="submit" color='primary'>Create Request</Button>
                    </FormGroup>

                </Form>
            </ModalBody>
        </Modal>
    )
}

export default CreateGatePassReq